import { joinParts } from '../utils'

export const ticket = {
  data: (cod: string) => joinParts('tickets', cod),
  bulk: (ids: string[]) => `/tickets?ids=${ids.join(',')}`,
}
